// extracted by mini-css-extract-plugin
export var image = "Img-module--image--bed3e";
export var paper = "Img-module--paper--2cb36";